import { useState } from "react";

/**
 * Hook to manage modal state for the Index page
 * Centralizes all modal open/close state management
 */
export function useModals() {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showIntegrationsModal, setShowIntegrationsModal] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [showDocumentationModal, setShowDocumentationModal] = useState(false);
  const [showHowItWorksModal, setShowHowItWorksModal] = useState(false);
  const [showPaymentRunModal, setShowPaymentRunModal] = useState(false);
  const [showSavingsModal, setShowSavingsModal] = useState(false);
  const [showPaymentWindowModal, setShowPaymentWindowModal] = useState(false);
  const [showACHHistoryModal, setShowACHHistoryModal] = useState(false);
  const [showBudgetDetailModal, setShowBudgetDetailModal] = useState(false);
  const [showBudgetModal, setShowBudgetModal] = useState(false);
  const [showAprModal, setShowAprModal] = useState(false);
  const [showManualInput, setShowManualInput] = useState(false);

  return {
    // Upload & Input
    showUploadModal,
    setShowUploadModal,
    showManualInput,
    setShowManualInput,
    // Info Modals
    showAboutModal,
    setShowAboutModal,
    showFeedbackModal,
    setShowFeedbackModal,
    showHelpModal,
    setShowHelpModal,
    showDocumentationModal,
    setShowDocumentationModal,
    showHowItWorksModal,
    setShowHowItWorksModal,
    // Feature Modals
    showIntegrationsModal,
    setShowIntegrationsModal,
    showPaymentRunModal,
    setShowPaymentRunModal,
    showSavingsModal,
    setShowSavingsModal,
    showPaymentWindowModal,
    setShowPaymentWindowModal,
    showACHHistoryModal,
    setShowACHHistoryModal,
    // Budget Modals
    showBudgetDetailModal,
    setShowBudgetDetailModal,
    showBudgetModal,
    setShowBudgetModal,
    showAprModal,
    setShowAprModal,
  };
}
